var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{attrs:{"switch":"","inline":"","uncheckedValue":0,"value":1},model:{value:(_vm.vip),callback:function ($$v) {_vm.vip=$$v},expression:"vip"}},[_vm._v(" خرید جدا از ترم ")])}
var staticRenderFns = []

export { render, staticRenderFns }